import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Media } from '../../structures/models/media/media';
import { fullTransform } from '../../utils/cloudinaryTransformations';
import { PUPPY_DEFAULT_IMAGE } from '../../utils/constants';
import { setFallbackImage } from '../../utils/imageHelper';

type Props = {
  photos: Media[],
  maxToDisplay?: number,
  className?: string,
  alt?: string,
  useFullTransform?: boolean,
}

type GalleryPhotoProps = {
  photo: Media,
  alt: string,
  bootstrapSize: number,
  useFullTransform?: boolean,
}

const GalleryPhoto: React.FC<GalleryPhotoProps> = ({
  photo,
  alt,
  bootstrapSize,
  useFullTransform,
}) => {
  return (
    <Col xs={bootstrapSize} className="img-container">
      <img
        src={useFullTransform
          ? fullTransform(photo.file_url)
          : photo.file_url}
        onError={(e) => {
          setFallbackImage(e, PUPPY_DEFAULT_IMAGE);
        }}
        alt={alt}
      />
    </Col>
  );
};

const SimplePhotoGallery: React.FC<Props> = (data) => {
  const {
    photos,
    maxToDisplay = photos.length,
    className = '',
    useFullTransform,
    alt,
  } = data;

  if (photos.length < 1) {
    return <></>;
  }

  const numPhotos = Math.min(photos.length, maxToDisplay);
  // This will work reasonably for any number of photos
  const bootstrapNum = Math.max(2, Math.floor(12 / Math.ceil(Math.sqrt(numPhotos))));

  return (
    <Row className={`photo-gallery-container justify-content-center ${className}`}>
      {
        photos
          .slice(0, numPhotos)
          .map((photo, index) => {
            return (
              <GalleryPhoto
                key={photo.public_id}
                photo={photo}
                useFullTransform={useFullTransform}
                alt={alt ? `${alt} #${index + 1}` : ''}
                bootstrapSize={bootstrapNum}
              />
            );
          })
      }
    </Row>
  );
};

export default SimplePhotoGallery;
